export default "__VITE_ASSET__7jsV8ggF__"